import { Form } from "react-bootstrap";

import { faX } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const DefaultColumnFilter = ({
	column: { filterValue, preFilteredRows, setFilter },
}) => {
	const count = preFilteredRows.length;

	return (
		<>
			<Form.Control
				style={{ padding: "2px", paddingTop: "5px", fontSize: "13px" }}
				value={filterValue || ""}
				onChange={(e) => {
					setFilter(e.target.value || undefined);
				}}
				placeholder={`Search ${count} records...`}
			/>
			<FontAwesomeIcon
				onClick={() => {
					setFilter();
				}}
				className="clearSearch"
				hidden={!(filterValue && filterValue.length > 0)}
				variant="secondary"
				icon={faX}
			/>
		</>
	);
};

